import React from "react";
import {toast} from "react-toastify";

const CsvFileUploader = ({
                             label = "Upload CSV File Here",
                             exampleLink = "/knaek_codes.csv",
                             onValidFile,
                             onInvalidFile,
                             inputRef,
                             width = "300px",
                             height = "50px",
                         }) => {

    const handleChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const fileExtension = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
        const allowedExtensions = ["csv"];

        if (allowedExtensions.includes(fileExtension)) {
            onValidFile && onValidFile(file);
        } else {
            if (onInvalidFile) {
                onInvalidFile(file);
            } else {
                toast.error("Invalid file extension. Please select a CSV file.");
            }
        }
    };
    return (
        <div className="form-group mb-3">
            <label className="text-black font-w500">
                {label}{" "}
                {exampleLink && (
                    <a href={exampleLink} target="_blank" rel="noopener noreferrer" className="text-primary">
                        (Download example)
                    </a>
                )}
            </label>
            <input
                type="file"
                className="form-control"
                style={{ height, width }}
                accept=".csv"
                onChange={handleChange}
                ref={inputRef}
            />
        </div>
    );
};

export default CsvFileUploader;
